<template>
  <pt-award-audit class="pt-award-audit__withData" ref="table" @auditReview="auditReview" :isReview="isReview" :statisticsData="statisticsData" @closeDialog='closeDialog'
  @oldCudtomerRemindPay="oldCudtomerRemindPay" :exportLoading="exportLoading" @BringNewAuditExport="BringNewAuditExport" :business-type="businessType"></pt-award-audit>
</template>

<script>
import PtAwardAudit from './index'
export default {
  name: 'pt-award-audit__withData',
  components: {
    'pt-award-audit': PtAwardAudit
  },
  props: {
    businessType: {
      type: String
    }
  },
  data () {
    return {
      isReview: false,
      statisticsData: {},
      exportLoading: false
    }
  },
  watch: {
  },
  methods: {
    BringNewAuditExport (data) {
      this.exportLoading = true
      this.$store.dispatch('BringNewAuditExport', data).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出脐荐康奖励失败')
      })
    },
    oldCudtomerRemindPay (ids) {
      let data = {
        ids: ids
      }
      this.$store.dispatch('oldCudtomerRemindPay', data).then(res => {
        this.$message.success('催费消息发送成功')
        this.$refs.table.getTableData()
      }).catch(err => {
        this.$message.error(err || '催费消息发送失败')
      })
    },
    closeDialog () {
      this.isReview = false
    },
    auditReview (ids, auditStatus, userType) {
      if (auditStatus === 'SALES_COMPLETED') {
        this.bringNewRewardStatistics(ids)
      } else {
        this.bringNewRewardStatisticsSaler(ids)
      }
    },
    bringNewRewardStatistics (ids) {
      // this.loading = true
      this.$store.dispatch('bringNewRewardStatistics', ids).then(res => {
        // this.loading = false
        this.statisticsData = res
        if (res.approvedNewUserTotal === 0 && res.approvedOldUserTotal === 0) {
          this.isReview = true
        } else {
          this.$confirm('您选择的' + res.selectedRecordTotal + '条奖励记录中，有' + res.approvedNewUserTotal + '个新用户、' +
        res.approvedOldUserTotal + '个老用户已做过财务审核处理（已完成/已驳回），将对待审核状态的' + res.canApprovalUserTotal + '个用户进行批量审核', '批量发放提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning' }).then(_ => {
            if (res.canApprovalUserTotal > 0) {
              this.isReview = true
            } else {
              this.$refs.table.clearSelection()
            }
          }).catch(_ => {
            this.$refs.table.clearSelection()
          })
        }
      }).catch(err => {
        // this.loading = false
        this.$message.error(err || '统计人数失败')
      })
    },
    bringNewRewardStatisticsSaler (ids) {
      // this.loading = true
      this.$store.dispatch('bringNewRewardStatisticsSaler', ids).then(res => {
        // this.loading = false
        this.statisticsData = res
        if (res.approvedNewUserTotal === 0 && res.approvedOldUserTotal === 0) {
          this.isReview = true
        } else {
          this.$confirm('您选择的' + res.selectedRecordTotal + '条奖励记录中，有' + res.approvedNewUserTotal + '个新用户、' +
        res.approvedOldUserTotal + '个老用户已做过客服审核处理（已完成/已驳回），将对待审核状态的' + res.canApprovalUserTotal + '个用户进行批量审核', '批量发放提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning' }).then(_ => {
            if (res.canApprovalUserTotal > 0) {
              this.isReview = true
            } else {
              this.$refs.table.clearSelection()
            }
          }).catch(_ => {
            this.$refs.table.clearSelection()
          })
        }
      }).catch(err => {
        // this.loading = false
        this.$message.error(err || '统计人数失败')
      })
    }
  },
  activated () {
    console.log(3333)
  }
}
</script>
